<template>
  <el-container class="admin-layout">
    <el-header :height="`${ADMIN_HEADER_HEIGHT}px`" class="admin-header">
      <div class="admin-header-left">
        <div class="admin-brand">
          <span class="admin-brand-mark">KG</span>
          <span class="admin-title">知识图谱管理后台</span>
        </div>
        <el-button link class="admin-back-link" @click="router.push('/search')">
          返回前台
        </el-button>
        <div class="admin-header-graph-filter">
          <span class="admin-header-graph-label">图谱</span>
          <el-select
            v-model="graphId"
            placeholder="请选择图谱"
            style="width: 200px"
            :loading="graphLoading"
          >
            <el-option
              v-for="g in graphOptions"
              :key="g.value"
              :label="g.label"
              :value="g.value"
            />
          </el-select>
        </div>
      </div>
      <header-login />
    </el-header>
    <el-container>
      <el-aside :width="`${ADMIN_SIDEBAR_WIDTH}px`" class="admin-aside">
        <el-menu class="admin-menu" :default-active="activeMenu" router>
          <el-menu-item index="/admin/graphs">
            <el-icon><DataAnalysis /></el-icon>
            <span>图谱管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/entity-categories">
            <el-icon><Collection /></el-icon>
            <span>实体类别</span>
          </el-menu-item>
          <el-menu-item index="/admin/relationship-categories">
            <el-icon><Connection /></el-icon>
            <span>关系类别</span>
          </el-menu-item>
          <el-menu-item index="/admin/entities">
            <el-icon><Box /></el-icon>
            <span>实体管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="admin-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  Box,
  Collection,
  Connection,
  DataAnalysis,
} from "@element-plus/icons-vue";
import HeaderLogin from "@/components/common/layout/HeaderLogin.vue";
import { useAdminSelectedGraph } from "@/composables/useAdminSelectedGraph";

const ADMIN_HEADER_HEIGHT = 60;
const ADMIN_SIDEBAR_WIDTH = 220;

const route = useRoute();
const router = useRouter();

const { graphId, graphOptions, graphLoading, ensureGraphOptionsLoaded } =
  useAdminSelectedGraph();

const activeMenu = computed(() => route.path);

onMounted(() => {
  ensureGraphOptionsLoaded();
});
</script>

<style lang="scss">
@import "@/assets/styles/admin/index.scss";
</style>
